import React, { useState } from 'react';
import { post } from '../../Auths/AuthToken';
import setUiMessage from '../../../Utilities/Tostify';
import { useSelector } from 'react-redux';

function EmergenyContact({ data, patientId, reload }) {
  const [isEdit, setIsEdit] = useState(false);
  const [allDataEdit, setAllDataEdit] = useState(null);

  const { user } = useSelector((state) => state.auth);
  const [formValues, setFormValues] = useState({
    emergency_email_id: '',
    emergency_first_name: '',
    emergency_last_name: '',
    emergency_middle_name: '',
    emergency_relationship: '',
    emergency_telephone: '',
  });

  const handleIdentityChange = async () => {
    setIsEdit(true);
    try {
      const response = await post('api/patient/Patient/editPatientProfile', {
        patientId: patientId,
      });
      if (response?.status === 200) {
        setAllDataEdit(response?.data);
        const patientDetails = response?.data?.patientDetail;
        setFormValues((ele) => {
          return {
            ...ele,
            emergency_email_id: patientDetails?.emergency_email_id,
            emergency_first_name: patientDetails?.emergency_first_name,
            emergency_last_name: patientDetails?.emergency_last_name,
            emergency_middle_name: patientDetails?.emergency_middle_name,
            emergency_relationship:
              patientDetails?.emergency_relationship || '',
            emergency_telephone: patientDetails?.emergency_telephone,
          };
        });
      }
    } catch (e) {
      setUiMessage('err', e.message);
    }
  };

  const handleFieldChange = ({ target: { id, value } }) => {
    setFormValues((ele) => {
      return { ...ele, [id]: value };
    });
  };

  const handleSave = async () => {
    if (
      (formValues?.emergency_first_name ||
        formValues?.emergency_middle_name ||
        formValues?.emergency_last_name ||
        formValues?.emergency_telephone ||
        formValues?.emergency_email_id) &&
      (formValues?.emergency_relationship === '0' ||
        formValues?.emergency_relationship === '')
    ) {
      setUiMessage('err', 'Please select relationship.');
    } else {
      try {
        const response = await post('api/patient/Patient/updatePatient', {
          updateInfo: 'Emergency-Contact',
          flag: '1',
          patient_id: patientId,
          emergency_first_name: formValues?.emergency_first_name,
          emergency_middle_name: formValues?.emergency_middle_name,
          emergency_last_name: formValues?.emergency_last_name,
          emergency_telephone: formValues?.emergency_telephone,
          emergency_email_id: formValues?.emergency_email_id,
          emergency_relationship: formValues?.emergency_relationship,
          loginUserId: user?.id,
        });
        if (response?.status === 200) {
          setIsEdit(false);
          reload();
        }
      } catch (e) {
        setUiMessage('err', e.message);
      }
    }
  };
  return (
    <>
      {isEdit ? (
        <div className="demo-main-con-sec">
          <div className="demo-main-con-chld-hdr">
            <div className="chld-hdr-hdng"> Emergeny Contact:</div>
            <div className="chld-hdr-edt">
              <span className="demo-edt-icn">
                <div className="actn-No" onClick={() => setIsEdit(false)}>
                  Cancel
                </div>
                <div className="actn-yes" onClick={handleSave}>
                  Save
                </div>
              </span>
            </div>
          </div>
          <div className="demo-main-con-chld-bdy">
            <div className="flex-sec alt-rw">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">First Name:</span>
                <span className="nsu-act-val maroon">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="emergency_first_name"
                    value={formValues.emergency_first_name || ''}
                    onChange={handleFieldChange}
                  />
                </span>
              </div>

              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Middle Name:</span>
                <span className="nsu-act-val maroon">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="emergency_middle_name"
                    value={formValues.emergency_middle_name || ''}
                    onChange={handleFieldChange}
                  />
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Last Name:</span>
                <span className="nsu-act-val maroon">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="emergency_last_name"
                    value={formValues.emergency_last_name || ''}
                    onChange={handleFieldChange}
                  />
                </span>
              </div>
            </div>
            <div className="flex-sec">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Phone:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="emergency_telephone"
                    value={formValues.emergency_telephone || ''}
                    onChange={handleFieldChange}
                    maxLength="10"
                  />
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Email:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="emergency_email_id"
                    value={formValues.emergency_email_id || ''}
                    onChange={handleFieldChange}
                  />
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Relationship:</span>
                <span className="nsu-act-val">
                  <select
                    className="inpt-width-nw"
                    id="emergency_relationship"
                    value={formValues.emergency_relationship}
                    onChange={handleFieldChange}
                  >
                    <option value="">Select</option>
                    {allDataEdit?.emergencyContactDetailArr?.relationship &&
                      allDataEdit?.emergencyContactDetailArr?.relationship.map(
                        (item, i) => {
                          return (
                            <option key={i} value={item?.id}>
                              {item?.title}
                            </option>
                          );
                        }
                      )}
                  </select>
                </span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="demo-main-con-sec">
          <div className="demo-main-con-chld-hdr">
            <div className="chld-hdr-hdng">Emergeny Contact:</div>
            <div className="chld-hdr-edt">
              <span className="demo-edt-icn" onClick={handleIdentityChange}>
                &#9998;
              </span>
            </div>
          </div>
          <div className="demo-main-con-chld-bdy">
            <div className="flex-sec alt-rw">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">First Name:</span>
                <span className="nsu-act-val maroon">
                  {data?.emergency_first_name}
                </span>
              </div>

              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Middle Name:</span>
                <span className="nsu-act-val maroon">
                  {data?.emergency_middle_name}
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Last Name:</span>
                <span className="nsu-act-val maroon">
                  {data?.emergency_last_name}
                </span>
              </div>
            </div>
            <div className="flex-sec">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Phone:</span>
                <span className="nsu-act-val">{data?.emergency_telephone}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Email:</span>
                <span className="nsu-act-val">{data?.emergency_email_id}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Relationship:</span>
                <span className="nsu-act-val">
                  {data?.emergency_relationship}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default EmergenyContact;
